import * as React from 'react';
import { useState, useEffect } from 'react';
import Modal from '../../shared/Modal';
import { search, IAccountDetails } from '../../services/account';
import { add } from '../../services/partner'
import { defineMessages, FormattedMessage, injectIntl, InjectedIntlProps, FormattedHTMLMessage } from 'react-intl';
import DatabaseSelect from '../shared/DatabaseSelect';
import { Async } from 'react-select';

export default injectIntl((props: InjectedIntlProps & { onSave: () => void, accountDetails: IAccountDetails, buttonClassName?: string, buttonStyle?: any }) => {
    const [selectedDatabaseName, setSelectedDatabaseName] = useState<string | null>(null);
    const [hasSubmitted, setHasSubmitted] = useState<boolean>(false);
    const [defaultRecipientOptions, setDefaultRecipientOptions] = useState<any[]>([]);
    const [organization, setOrganization] = useState<{ label: string, value: string } | null>(null);

    const messages = defineMessages({
        serverError: {
            id: 'dash.partner.request.err',
            defaultMessage: 'There was an error contacting the server. Please reload the page and try again.'
        },
        searchOrgs: {
            id: 'partner.request.search.placeholder',
            defaultMessage: 'Search Organizations'
        },
        findClient: {
            id: 'dash.partner.request.find',
            defaultMessage: 'Please search for an organization',
        },
        clientNotFound: {
            id: 'dash.partner.request.not.found',
            defaultMessage: 'No organizations found with that name',
        },
        typeToSearch: {
            id: 'dash.partner.request.select.type',
            defaultMessage: 'Type to search...'
        }
    });

    useEffect(() => {
        loadOrgOptions('*', setDefaultRecipientOptions)
    }, [])

    const loadOrgOptions = async (inputValue: string, callback: any) => {
        const results = await search(inputValue, 10, true);
        if (results.results === undefined) return;
        const options = results.results.map(result => ({
            value: result.name,
            label: result.organization,
        }));
        callback(options);
    };

    const renderDatabaseSelect = () => {
        if (!organization) return <noscript />
        return (
            <DatabaseSelect
                hidePartnerDatabases
                errorMessage={!selectedDatabaseName && hasSubmitted && "You must select a database to add a partner."}
                currentModalId="requestPartnersModal"
                onChange={setSelectedDatabaseName}
                defaultMessage={"Select the Database You Want to Join"}
                canCreate={props.accountDetails && props.accountDetails.subscriptionLevel > 0}
                account={organization.value}
                noDatabasesMessage={"You must have a database to invite partners to join!"} />
        )
    }

    const request = async () => {
        if (!selectedDatabaseName || !organization) {
            setHasSubmitted(true);
            return;
        }
        const result = await add(organization.value, selectedDatabaseName)
        if (result.success) {
            $('#requestPartnersModal').modal('hide')
            props.onSave()
        } else {
            alert(result.message || 'There was an error sending your partner request. Please try again at a later time.')
        }
    }

    const invitePartnersActionButtons = [
        <button type="button" className="primary " key="done-button" onClick={request} disabled={!selectedDatabaseName || !organization}>
            <FormattedMessage id="dash.partner.invite.btn" defaultMessage="Send Request" />
        </button>
    ];

    const renderAccountSearch = () => {
        return (
            <Async
                cacheOptions
                id="clients"
                defaultOptions={defaultRecipientOptions}
                loadOptions={loadOrgOptions}
                noOptionsMessage={({ inputValue }) =>
                    inputValue.length < 3
                        ? props.intl.formatMessage(messages.findClient)
                        : props.intl.formatMessage(messages.clientNotFound)
                }
                onChange={(x: any) => setOrganization(x)}
                placeholder={props.intl.formatMessage(messages.typeToSearch)}
            />
        )
    }

    return (
        <React.Fragment>
            <button
                className={`primary h3 px-3 py-2 m-0 mx-3 ${props.buttonClassName}`}
                data-toggle="modal"
                data-target="#requestPartnersModal"
                style={props.buttonStyle || {}}>
                <FormattedMessage id="dash.partner.request.invite" defaultMessage="Request to Partner" />
            </button>
            <Modal
                large
                id="requestPartnersModal"
                title="Request a Partnership"
                actionButtons={invitePartnersActionButtons}>
                <p className="text-left"><FormattedHTMLMessage id="dash.partner.invite.text" defaultMessage={`
                    Please type in the name of the organization you wish to partner with in the search box below.<br/>
                    They will receive a notification of your request to partner and must accept it to link
                    with their account and add resources to their database.`} /></p>
                {renderAccountSearch()}
                <br />
                {renderDatabaseSelect()}
            </Modal>
        </React.Fragment >
    );
});



// WEBPACK FOOTER //
// ./src/client/dashboard/RequestPartnerModal.tsx